import React, { Component } from "react";
import connect from "react-redux/es/connect/connect";
import { Button, Card, CardBody, CardTitle, Col, Label, Row, Table } from "reactstrap";
import axios from "axios";
import Alerts from "../../util/Alerts";
import BlkFormik from "../../util/BlkFormik";
import { Form } from "formik";
import { find_aseguradoras, find_companias, find_ram_grupos, find_ramos, find_ramos_ramgrp } from "../../api/CacheApi";
import { BlkCalendario } from "../../coms/BlkCalendario";
import ReactTable from "react-table";
import { on_select } from "./actions";
import { BlkField } from "../../coms/BlkField";
import { routes } from "../General";
import { has_role, pos } from "../../util/General";
import { Condiciones } from "./Condiciones";
import moment from "moment";
import "moment/locale/es";
import { ComboAsegurado } from "../ComboAsegurado";
import { Link } from "react-router-dom";
import { BeneficiosYellowCard } from "../../beneficios/BeneficiosComponents";

class Polizas extends Component {
    constructor() {
        super(...arguments);
        this.alert = React.createRef();
        this.form = React.createRef();
        this.state = {
            data: [],
            ramos: [],
            nombres: null,
            telfs: null,
            correos: null,
            asegs: [],
            agentes: [],
            companias: [],
            adicionales: [],
            pages: -1,
            page: 0,
            loading: false,
            cot: {},
            itemPoli: {},
            cdUbicacion: null,
            cdCotizacion: null,
            cdRamo: null,
            itemAdi: {},
            modalCondiciones: false,
            modalAsegurados: false,
            modalFacturacion: false,
            busquedaAvanzada: false,
            query: this.itemQuery(),
        };
    }

    itemQuery() {
        return {
            page: 0,
            pageSize: 10,
            poliza: "",
            ramo: 0,
            aseg: 0,
            comp: 0,
            desde: new Date(new Date().getFullYear() - 1, new Date().getMonth(), 1),
            hasta: new Date(),
            sorted: null,
            ci: this.props.user.cedula,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.user.cedula !== this.props.user.cedula) {
            this.fetchData({}, {});
        }
    }

    filterExcluidos(item) {
        if (item.nm.toUpperCase().indexOf("ASISTENCIA MEDICA INDIVIDUAL") >= 0) {
            return false;
        }
        if (item.nm.toUpperCase().indexOf("VIDA CRECIENTE (INDIVIDUAL)") >= 0) {
            return false;
        }
        if (item.nm.toUpperCase().indexOf("VIDA UNIVERSAL INDIVIDUAL") >= 0) {
            return false;
        }
        if (item.nm.toUpperCase().indexOf("VIDA TERMINO INDIVIDUAL") >= 0) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        find_ramos().then(resp => {
            let ramos = resp;
            find_ram_grupos().then(resp => {
                let areas = resp;
                find_ramos_ramgrp().then(resp => {
                    let ramosTmp = [];
                    resp.forEach(r => {
                        let item = Object.assign({}, r); //clono el item
                        item.nmRamo = ramos.find(ramo => ramo.cdRamo === item.cdRamo).nmRamo;
                        item.nmArea = areas.find(area => area.cdRamGrupo === item.cdRamGrupo).nmRamGrupo;
                        item.nm = item.nmRamo;
                        if (this.isVam(item) && this.filterExcluidos(item)) {
                            ramosTmp.push(item);
                        }
                    });
                    this.setState({ ramos: ramosTmp.sort((a, b) => a.nmRamo.localeCompare(b.nmRamo)) });
                });
            });
        });

        find_aseguradoras().then(resp => {
            this.setState({ asegs: resp });
        });
        find_companias().then(resp => {
            this.setState({ companias: resp });
        });
    }

    /**
     * funcion a ejecutarse cuando se da click en guardar desde el menu
     */
    onSubmit = (newValues, actions) => {
        this.setState(
            {
                query: { ...this.state.query, ...newValues, page: 0 },
                page: 0,
            },
            () => this.fetchData({}, actions)
        );
    };

    fetchData = (query = {}, actions) => {
        let query2 = Object.assign({}, this.state.query);
        query2.sorted = query.sorted;
        if (query.page >= 0) {
            query2.page = query.page;
            // query2.page = 1;
        }

        if (query.pageSize >= 0) {
            query2.pageSize = query.pageSize;
        }

        if (query2.page !== this.state.query.page || query2.page === 0) {
            axios
                .post(routes.api + "/polizas", query2)
                .then(resp => {
                    resp.data.content.forEach(p => {
                        if (p.tipo.indexOf("RENO") >= 0) {
                            p.tipo = "RENOVACIÓN";
                        }

                        if (p.tipo.indexOf("COTI") >= 0) {
                            p.tipo = "POLIZA NUEVA";
                        }
                    });

                    this.setState({
                        data: resp.data.content,
                        pages: resp.data.totalPages,
                        loading: false,
                        sorted: resp.data.sorted,
                        adicionales: [],
                    });
                    if (actions.setSubmitting) {
                        actions.setSubmitting(false);
                    }
                    resp.data.content?.length > 0 &&
                        document.getElementById("polizaVam").scrollIntoView({ behavior: "smooth" });
                })
                .catch(error => {
                    this.alert.current.handle_error(error);
                    if (actions.setSubmitting) {
                        actions.setSubmitting(false);
                    }
                });
        }
    };

    getEjecutivo = coti => {
        axios
            .get(routes.api + "/ejecutivoAdm", {
                params: {
                    id: coti.cdEjecutivo,
                    comp: coti.cdCompania,
                },
            })
            .then(resp => {
                this.setState({ nombres: resp.data.nombres, correos: resp.data.correos, telfs: resp.data.telefonos });
            });
    };

    onSelectAdicional = coti => {
        coti.isIndividual = coti.nmRamo.toLowerCase().indexOf("individual") >= 0;

        axios
            .get(routes.api + "/ubicacion", {
                params: {
                    cdCompania: coti.cdCompania,
                    cdUbicacion: coti.cdUbicacion,
                },
            })
            .then(resp => {
                this.setState(
                    {
                        cdUbicacion: resp.data.cdUbicacion,
                        cdRamo: resp.data.cdRamoCotizacion,
                        itemAdi: resp.data,
                        itemPoli: coti,
                    },
                    () => {
                        this.showCondiciones(true);
                    }
                );
            })
            .catch(error => {
                this.alert.current.handle_error(error);
            });
    };

    showCondiciones = open => {
        this.setState({ modalCondiciones: open });
    };

    showBusquedaAvanzada = open => {
        this.setState({ busquedaAvanzada: open });
    };

    isVam = r => {
        let vam = false;
        let ls_nm_grp_ramo = r.nmArea;

        if (pos(ls_nm_grp_ramo, "MEDICA") > 0) {
            //pb_actvam.TriggerEvent(Clicked!)
            vam = true;
        } else if (pos(ls_nm_grp_ramo, "VIDA") > 0) {
            //pb_actvam.TriggerEvent(Clicked!)
            vam = true;
        } else {
            vam = false;
        }
        return vam;
    };
    handleResetForm = resetForm => {
        this.setState({ ...this.state, query: this.itemQuery(), data: [], data1: [], selected: -1 });
        resetForm();
    };

    render() {
        return (
            <div className="content ">
                <Alerts ref={this.alert} />
                <Card>
                    <CardBody>
                        <CardTitle tag="h4">Pólizas</CardTitle>
                        <div className="container-fluid container-md">
                            <BlkFormik
                                initialValues={this.state.query}
                                onSubmit={this.onSubmit}
                                ref={this.form}
                                enableReinitialize={true}
                                validateOnChange={false}
                            >
                                {({ values, isSubmitting, setFieldValue, resetForm, submitForm }) => (
                                    <Form className="container">
                                        <Row>
                                            {(has_role(this.props.user, "ROLE_ADMIN") ||
                                                has_role(this.props.user, "ROLE_BROKER")) && (
                                                <div className="form-group col-lg-6">
                                                    <ComboAsegurado
                                                        name={"ci"}
                                                        setFieldValue={setFieldValue}
                                                        alert={this.alert}
                                                        values={values}
                                                    />
                                                </div>
                                            )}
                                            {(has_role(this.props.user, "ROLE_ADMIN") ||
                                                has_role(this.props.user, "ROLE_BROKER")) &&
                                                !this.state.busquedaAvanzada && (
                                                    <div className="form-group col-lg-6">
                                                        <div className="m-1">
                                                            <Button
                                                                type={"submit"}
                                                                className="mx-md-4 my-md-4 btn__yellow"
                                                                onClick={() => {
                                                                    submitForm();
                                                                    // this.state.data.length > 0 &&
                                                                    // document.getElementById('polizaVam')?.scrollIntoView({behavior: "smooth"});
                                                                }}
                                                                disabled={isSubmitting}
                                                            >
                                                                Buscar
                                                            </Button>
                                                        </div>
                                                    </div>
                                                )}
                                        </Row>
                                        <Row>
                                            <div className="form-group col-lg-6">
                                                <Button
                                                    className="btn my-md-4 btn__celeste-claro"
                                                    onClick={() => {
                                                        this.showBusquedaAvanzada(!this.state.busquedaAvanzada);
                                                    }}
                                                >
                                                    Búsqueda Avanzada
                                                </Button>
                                            </div>
                                        </Row>
                                        {this.state.busquedaAvanzada && (
                                            <>
                                                <Row>
                                                    <div className="form-group col-lg-6">
                                                        <Label>Póliza: </Label>
                                                        <BlkField
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Póliza"
                                                            name="poliza"
                                                        />
                                                    </div>
                                                    <div className="form-group col-lg-6">
                                                        <Label>Ramo: </Label>
                                                        <BlkField
                                                            component="select"
                                                            className="form-control w-100 inputTable"
                                                            name="ramo"
                                                        >
                                                            <option value="0">--TODOS--</option>
                                                            {this.state.ramos.map(ramo => (
                                                                <option key={ramo.cdRamo} value={ramo.cdRamo}>
                                                                    {ramo.nmRamo}
                                                                </option>
                                                            ))}
                                                        </BlkField>
                                                    </div>
                                                </Row>

                                                <Row>
                                                    <Col xs={12} sm={6}>
                                                        <Row>
                                                            <div className="form-group col-lg-6">
                                                                <Label>Desde: </Label>
                                                                <BlkField
                                                                    name="desde"
                                                                    placeholder="Ingrese Fecha"
                                                                    component={BlkCalendario}
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6">
                                                                <Label>Hasta: </Label>
                                                                <BlkField
                                                                    name="hasta"
                                                                    placeholder="Ingrese Fecha"
                                                                    component={BlkCalendario}
                                                                />
                                                            </div>
                                                        </Row>
                                                    </Col>
                                                    <div className="form-group col-lg-6">
                                                        <Label>Aseguradora: </Label>
                                                        <BlkField
                                                            component="select"
                                                            className="form-control w-100 inputTable"
                                                            name="aseg"
                                                        >
                                                            <option value="0">--TODOS--</option>
                                                            {this.state.asegs.map(aseg => (
                                                                <option
                                                                    key={aseg.cdAseguradora}
                                                                    value={aseg.cdAseguradora}
                                                                >
                                                                    {aseg.nmAlias}
                                                                </option>
                                                            ))}
                                                        </BlkField>
                                                    </div>
                                                </Row>
                                                <Row>
                                                    <div className="form-group col-lg-6">
                                                        <Button
                                                            type={"submit"}
                                                            className="mb-3 mr-2 btn btn__yellow"
                                                            onClick={submitForm}
                                                            disabled={isSubmitting}
                                                        >
                                                            Buscar
                                                        </Button>
                                                        <Button
                                                            className="mb-3 btn__celeste-claro"
                                                            onClick={() => this.handleResetForm(resetForm)}
                                                        >
                                                            Nueva Consulta
                                                        </Button>
                                                    </div>
                                                </Row>
                                            </>
                                        )}
                                    </Form>
                                )}
                            </BlkFormik>
                            {this.state.nombres && (
                                <div className={"container"}>
                                    <small className="fs12 d-flex d-sm-block flex-column">
                                        <span className="text-primary option">Ejec. Cuenta:</span>
                                        <span className="text-verde option mx-1">{this.state.nombres} </span>
                                        <span>
                                            <span className="text-primary option fa fa-envelope" />
                                            <a
                                                href={"mailto:" + this.state.correos}
                                                className={"text-decoration-underline mx-1"}
                                            >
                                                {this.state.correos}
                                            </a>
                                        </span>
                                        <span>
                                            <span className="text-primary option fa fa-phone" />
                                            <a
                                                href={"tel:" + this.state.telfs}
                                                className={"text-decoration-underline mx-1"}
                                            >
                                                {this.state.telfs}
                                            </a>
                                        </span>
                                    </small>
                                </div>
                            )}
                            <br />
                            <Label>Pólizas: </Label>
                            <div id={"polizaVam"} />
                            <Row>
                                <Col xs={12}>
                                    <ReactTable
                                        noDataText={"No se ha encontrado información"}
                                        previousText={"Anterior"}
                                        nextText={"Siguiente"}
                                        pageText={"Página"}
                                        rowsText={"filas"}
                                        ofText={"de"}
                                        columns={[
                                            {
                                                Header: "Cliente",
                                                minResizeWidth: 50,
                                                width: 200,
                                                sortable: false,
                                                accessor: "nmCliente",
                                            },
                                            {
                                                Header: "Aseguradora",
                                                minResizeWidth: 50,
                                                width: 140,
                                                sortable: false,
                                                accessor: "aseguradora",
                                            },
                                            {
                                                Header: "Ramo",
                                                minResizeWidth: 50,
                                                width: 200,
                                                sortable: false,
                                                accessor: "nmRamo",
                                            },
                                            {
                                                id: "fcDesde",
                                                sortable: false,
                                                Header: "Fc Desde",
                                                accessor: d => {
                                                    return moment(d.fcDesde)
                                                        .locale("moment/locale/es")
                                                        .local()
                                                        .format("DD/MM/YYYY");
                                                },
                                                minResizeWidth: 10,
                                                width: 100,
                                            },
                                            {
                                                id: "fcHasta",
                                                sortable: false,
                                                Header: "Fc Hasta",
                                                accessor: d => {
                                                    return moment(d.fcHasta)
                                                        .locale("moment/locale/es")
                                                        .local()
                                                        .format("DD/MM/YYYY");
                                                },
                                                minResizeWidth: 10,
                                                width: 100,
                                            },
                                            {
                                                Header: "Póliza",
                                                sortable: false,
                                                minResizeWidth: 10,
                                                accessor: "poliza",
                                                width: 140,
                                            },
                                            {
                                                Header: "Tipo Póliza",
                                                sortable: false,
                                                minResizeWidth: 10,
                                                accessor: "tipo",
                                            },
                                        ]}
                                        getTdProps={(state, rowInfo) => {
                                            if (rowInfo && rowInfo.row) {
                                                return {
                                                    onClick: (e, handleOriginal) => {
                                                        this.onSelectAdicional(rowInfo.original);
                                                        this.getEjecutivo(rowInfo.original);

                                                        this.setState({
                                                            selected: rowInfo.index,
                                                        });
                                                        if (handleOriginal) {
                                                            handleOriginal();
                                                        }
                                                    },
                                                    style: {
                                                        cursor: "pointer",
                                                        //backgroundColor: rowInfo.index === this.state.selected ? '#47b2a2' : 'white',
                                                        color:
                                                            rowInfo.index === this.state.selected ? "white" : "black",

                                                        height: 35,
                                                    },
                                                    className:
                                                        rowInfo.index === this.state.selected ? "bg-primary" : "white",
                                                };
                                            } else {
                                                return {};
                                            }
                                        }}
                                        manual
                                        data={this.state.data}
                                        pages={this.state.pages}
                                        loading={this.state.loading}
                                        onFetchData={this.fetchData}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                        page={this.state.page}
                                        pageSize={this.state.pageSize}
                                        onPageChange={page => this.setState({ page })}
                                        onPageSizeChange={(pageSize, page) => this.setState({ page, pageSize })}
                                    ></ReactTable>
                                </Col>
                            </Row>
                            <br />
                            <br />
                            <br />
                            <Row>
                                <Col xs={12}>
                                    {this.state.adicionales.length > 0 ? (
                                        <Table className="adjusttd text-center detallex" responsive>
                                            <thead className="text-primary">
                                                <tr>
                                                    <th>Información Adicional</th>
                                                    <th>Item</th>
                                                    <th>Grupo</th>
                                                    <th>Prima ($)</th>
                                                    <th>Plan Cobertura</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.adicionales.map(adicional => (
                                                    <tr key={adicional.cdRubro}>
                                                        <td className="st-50">
                                                            <div className="text-left">
                                                                <span
                                                                    className="text-info option px-2"
                                                                    title="Ver condiciones"
                                                                    onClick={() => {
                                                                        this.onSelectAdicional(adicional);
                                                                        this.showCondiciones(true);
                                                                    }}
                                                                >
                                                                    <i className="fas fa-eye mx-2" />
                                                                    Condiciones
                                                                </span>
                                                                <br />
                                                                <span
                                                                    className="text-primary option px-2"
                                                                    title="Ver dependientes"
                                                                    onClick={() => {
                                                                        this.onSelectAdicional(adicional);
                                                                        this.showAsegurados(true);
                                                                    }}
                                                                >
                                                                    <i className="fas fa-eye mx-2" />
                                                                    Dependientes
                                                                </span>
                                                                {this.state.itemPoli.isIndividual && (
                                                                    <>
                                                                        <br />
                                                                        <span
                                                                            className="text-primary option px-2"
                                                                            title="Ver dependientes"
                                                                            onClick={() => {
                                                                                this.onSelectAdicional(adicional);
                                                                                this.showFacturacion(true);
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-eye mx-2" />
                                                                            Facturación
                                                                        </span>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>{adicional.item}</td>
                                                        <td>{adicional.dscUbicacion}</td>
                                                        <td>{adicional.totPriActual}</td>
                                                        <td>{adicional.dscRubro}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    ) : null}
                                </Col>
                            </Row>
                        </div>
                    </CardBody>
                </Card>
                <Condiciones
                    open={this.state.modalCondiciones}
                    item={this.state.itemAdi}
                    toggleModal={this.showCondiciones}
                    alert={this.alert.current}
                    poliza={this.state.itemPoli}
                    isIndividual={this.state.itemPoli.isIndividual}
                    cdObjCotizacion={this.state.itemPoli.cdObjCotizacion}
                    ubicacion={this.state.cdUbicacion}
                    cotizacion={this.state.itemPoli.cdCotizacion}
                    ramo={this.state.cdRamo}
                    cedula={this.props.user.cedula}
                    user={this.props.user}
                />
                <BeneficiosYellowCard to={"/list/beneficios/vam"} />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    auth: state.auth,
});

const mapDispatchToProps = {
    on_select,
};
export default connect(mapStateToProps, mapDispatchToProps)(Polizas);
